<template>
	<div class="content">
		<el-row>
			<el-form :inline="true" :model="formInline">
				<el-form-item label="姓名">
					<el-input v-model="formInline.name" placeholder="请输入" clearable></el-input>
				</el-form-item>
				<!-- <el-form-item label="身份证后六位">
					<el-input v-model="formInline.idCardNumber" placeholder="请输入" clearable></el-input>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="query">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="clickImp">导入</el-button>
				</el-form-item>
			</el-form>
		</el-row>
		<el-row>
			<el-table :data="tableData" style="width: 100%" height="80vh" :cell-style="{ 'text-align': 'center' }"
				:header-cell-style="{ 'text-align': 'center', color: '#000', 'background': '#F5F7FA' }" stripe>
				<el-table-column type="index" label="序号" width="50"></el-table-column>
				<el-table-column prop="name" label="参会人员姓名"></el-table-column>
				<!-- <el-table-column prop="idCardNumber" label="身份证后六位"></el-table-column> -->
				<!-- <el-table-column prop="meetingSeatNumber" label="会议座位号"></el-table-column> -->
				<el-table-column prop="dinnerTableNumber" label="晚宴桌号"></el-table-column>
			</el-table>
		</el-row>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	data() {
		return {
			url: "",
			formInline: {
				name: "",
				idCardNumber: ""
			},
			tableData: [],
		};
	},
	created() {
		this.url = window.PLATFROM_CONFIG.url;
		this.query();
	},
	methods: {
		query() {
			axios.post(this.url + '/participant/findList', this.formInline).then(res => {
				this.tableData = res.data.data;
			})
		},
		clickImp() {
			axios.defaults.timeout = 1000 * 60 * 60 * 2;
			const _this = this;

			const fileType = ['xls', 'xlsx']
			const inputFile = document.createElement("input")
			inputFile.type = "file"
			inputFile.style.display = "none"
			document.body.appendChild(inputFile)
			inputFile.click()
			inputFile.addEventListener("change", () => {
				const file = inputFile.files[0];
				var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
				if (!fileType.includes(testmsg)) {
					_this.$message.warning("上传的文件格式只能是,xls,xlsx");
					document.body.removeChild(inputFile);
					return false;
				}
				const loading = _this.$loading({
					lock: true,
					text: '处理数据中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const formData = new FormData();
				formData.append("file", file);
				axios({
					method: 'post',
					url: _this.url + "/participant/impParticipant",
					data: formData,
					responseType: "blob",
				}).then(res => {
					if (res.data.type == 'application/json') {
						const fileReader = new FileReader()
						fileReader.readAsText(new Blob([res.data], { type: 'application/octet-stream' }), 'utf-8')
						fileReader.onload = () => {
							const msg = JSON.parse(fileReader.result)
							if (msg.code == 200) {
								_this.$message.success("操作成功");
							} else {
								_this.$message.error("处理失败，请稍后重试");
							}
						}
					} else {
						const aEle = document.createElement("a");
						const href = window.URL.createObjectURL(res.data);
						aEle.href = href;
						aEle.download = "上传失败原因.xlsx";
						document.body.appendChild(aEle);
						aEle.click();
						document.body.removeChild(aEle);
						window.URL.revokeObjectURL(href);
						_this.$message.warning("上传失败，请查看失败原因");
						_this.downShow = false;
					}
					loading.close();
					_this.query();
				}).catch(res => {
					_this.$message.error("处理失败，请稍后重试");
					loading.close();
				})
			})
		},
	}
}
</script>

<style scoped>
.content {
	padding: 40px;
}
</style>